import { apiRequest } from './apiService';

export const fetchSalesProducts = async () => {
  return await apiRequest('/sales/sales-products', 'GET');
};
export const fetchSalesCategory = async () => {
  return await apiRequest('/sales/sales-categories', 'GET');
};

export const fetchSalesCategoryById = async (id: any) => {
  return await apiRequest(`/sales/sales-categories/${id}`, 'GET');
};

export const createSalesCategory = async (categoryData: any) => {
  return await apiRequest('/sales/sales-categories', 'POST', categoryData);
};
export const updateSalesCategory = async (id: any, categoryData: any) => {
  return await apiRequest(`/sales/sales-categories/${id}`, 'PUT', categoryData);
};
